<div class="box-table">
	<span class="title-accordion" [class.active]="!isCollapsed" (click)="isCollapsed = !isCollapsed"
		(keypress)="isCollapsed = !isCollapsed">
		{{ labels().APEX_TABLE_TITLE }}
		<div class="fake-material-icon icon-expand expand"></div>
	</span>
	<table aria-label="Apex measures" class="table" [ngbCollapse]="isCollapsed">
		<thead>
			<tr>
				<th></th>
				@if (hasAP) { <th>{{ labels().APEX_TABLE_AP_HEADER }}</th> }
				@if (hasLT) { <th>{{ labels().APEX_TABLE_LT_HEADER }}</th> }
			</tr>
		</thead>
		<tbody>
			@if (isFemur || isLongLeg) {
			<tr>
				<td>{{ labels().APEX_TABLE_FEMUR }}</td>
				@if (hasAP) { <td [highlightCell]="apFemurMeasure">{{ apFemurMeasure }}</td> }
				@if (hasLT) { <td></td> }
			</tr>
			}
			@if (isTibia || isLongLeg) {
			<tr>
				<td>{{ labels().APEX_TABLE_TIBIA }}</td>
				@if (hasAP) { <td [highlightCell]="apTibiaMeasure">{{ apTibiaMeasure }}</td> }
				@if (hasLT) { <td [highlightCell]="ltTibiaMeasure">{{ ltTibiaMeasure }}</td> }
			</tr>
			}
		</tbody>
	</table>

	<!--AXIAL ROTATION-->
	@if (axialRotForm) {
	<form [formGroup]="axialRotForm">
		<table class="table" aria-label="Axial rotation measures" [ngbCollapse]="isCollapsed">
			<thead>
				<tr>
					<th colspan="2">{{ labels().APEX_TABLE_AXIAL_ROTATION_TITLE }}</th>
				</tr>
			</thead>
			<tbody>
				@if (isFemur || isLongLeg) {
				<tr>
					<td>{{ labels().APEX_TABLE_FEMUR }}</td>
					<td>
						<span>{{ labels().INS_CLINIC_ASSESS_VAL }}</span>
						<input type="text" autocomplete="off" maxlength="2" name="axialRotFemur" formControlName="axialRotFemur"
							[readonly]="stateType !== stateTypeEnum.deformityAnalysis" (keyup.enter)="updateAxialRotFemur()"
							(blur)="updateAxialRotFemur()" [class.is-invalid]="axialRotForm.controls['axialRotFemur'].invalid" />
						<div class="form-group pb-0">
							<div class="custom-control custom-radio custom-control-inline" style="margin-right: 2rem;">
								<input type="radio" id="axialRotFemur_external" name="axialRotSignFemur" class="custom-control-input"
									formControlName="axialRotSignFemur" (click)="updateAxialRotSignFemur(axialRotEnum.external)"
									(keypress)="updateAxialRotSignFemur(axialRotEnum.external)" [value]="axialRotEnum.external"
									[attr.disabled]="stateType !== stateTypeEnum.deformityAnalysis ? true : null" />
								<label class="custom-control-label" for="axialRotFemur_external">
									{{ labels().APEX_TABLE_AXIAL_ROTATION_EXTERNAL }}
								</label>
							</div>
							<div class="custom-control custom-radio custom-control-inline">
								<input type="radio" id="axialRotFemur_internal" name="axialRotSignFemur" class="custom-control-input"
									formControlName="axialRotSignFemur" (click)="updateAxialRotSignFemur(axialRotEnum.internal)"
									(keypress)="updateAxialRotSignFemur(axialRotEnum.internal)" [value]="axialRotEnum.internal"
									[attr.disabled]="stateType !== stateTypeEnum.deformityAnalysis ? true : null" />
								<label class="custom-control-label" for="axialRotFemur_internal">
									{{ labels().APEX_TABLE_AXIAL_ROTATION_INTERNAL }}
								</label>
							</div>
						</div>
					</td>
				</tr>
				}
				@if (isTibia || isLongLeg) {
				<tr>
					<td>{{ labels().APEX_TABLE_TIBIA }}</td>
					<td>
						<span>{{ labels().INS_CLINIC_ASSESS_VAL }}</span>
						<input type="text" autocomplete="off" maxlength="2" name="axialRotTibia" formControlName="axialRotTibia"
							[readonly]="stateType !== stateTypeEnum.deformityAnalysis" (keyup.enter)="updateAxialRotTibia()"
							(blur)="updateAxialRotTibia()" [class.is-invalid]="axialRotForm.controls['axialRotTibia'].invalid" />
						<div class="form-group pb-0">
							<div class="custom-control custom-radio custom-control-inline" style="margin-right: 2rem;">
								<input type="radio" id="axialRotTibia_external" name="axialRotSignTibia" class="custom-control-input"
									formControlName="axialRotSignTibia" (click)="updateAxialRotSignTibia(axialRotEnum.external)"
									(keypress)="updateAxialRotSignTibia(axialRotEnum.external)" [value]="axialRotEnum.external"
									[attr.disabled]="stateType !== stateTypeEnum.deformityAnalysis ? true : null" />
								<label class="custom-control-label" for="axialRotTibia_external">
									{{ labels().APEX_TABLE_AXIAL_ROTATION_EXTERNAL }}
								</label>
							</div>
							<div class="custom-control custom-radio custom-control-inline">
								<input type="radio" id="axialRotTibia_internal" name="axialRotSignTibia" class="custom-control-input"
									formControlName="axialRotSignTibia" (click)="updateAxialRotSignTibia(axialRotEnum.internal)"
									(keypress)="updateAxialRotSignTibia(axialRotEnum.internal)" [value]="axialRotEnum.internal"
									[attr.disabled]="stateType !== stateTypeEnum.deformityAnalysis ? true : null" />
								<label class="custom-control-label" for="axialRotTibia_internal">
									{{ labels().APEX_TABLE_AXIAL_ROTATION_INTERNAL }}
								</label>
							</div>
						</div>
					</td>
				</tr>
				}
			</tbody>
		</table>
	</form>
	}
</div>